import { Icon } from "@iconify/react";
import googleFill from "@iconify/icons-eva/google-fill";
import twitterFill from "@iconify/icons-eva/twitter-fill";
import facebookFill from "@iconify/icons-eva/facebook-fill";
// material
import { Stack, Button, Divider, Typography } from "@mui/material";

import {
  FacebookAuthProvider,
  GoogleAuthProvider,
  getAuth,
  signInWithPopup,
} from "firebase/auth";
import { useCallback } from "react";
import { useNavigate } from "react-router";

import { ROUTES } from "../../../commons";

const alertAccountExistsWithDifferentCredential = (error) => {
  if (error.code === "auth/account-exists-with-different-credential") {
    const methods = error.customData._tokenResponse.verifiedProvider;

    alert(`동일한 이메일로 이미 가입하신 것으로 확인되었습니다. 아래 중 하나로 먼저 Sign in 하신 후 프로필 페이지에서 연동하시기 바랍니다.

[이미 가입한 계정 종류]
${methods.join("/n")}`);
  }
};

// ----------------------------------------------------------------------

export default function AuthSocial() {
  const navigate = useNavigate();

  const google = useCallback(async () => {
    try {
      await signInWithPopup(getAuth(), new GoogleAuthProvider());

      // This gives you a Google Access Token. You can use it to access the Google API.
      // const credential = GoogleAuthProvider.credentialFromResult(result);
      // const token = credential.accessToken;
      // The signed-in user info.
      // const user = result.user;

      const next = new URLSearchParams(document.location.search).get("next");
      navigate(next || ROUTES.Root, { replace: true });
    } catch (err) {
      console.error(err);
      // console.error(JSON.stringify(err));

      alertAccountExistsWithDifferentCredential(err);
    }
  }, [navigate]);

  const facebook = useCallback(async () => {
    const auth = getAuth();
    const provider = new FacebookAuthProvider();
    provider.setCustomParameters({
      display: "popup",
    });

    try {
      await signInWithPopup(auth, provider);

      // The signed-in user info.
      // const user = result.user;
      // console.log({ user });

      // This gives you a Facebook Access Token. You can use it to access the Facebook API.
      // const credential = FacebookAuthProvider.credentialFromResult(result);
      // const accessToken = credential.accessToken;

      const next = new URLSearchParams(document.location.search).get("next");
      navigate(next || ROUTES.Root, { replace: true });
    } catch (err) {
      console.error(err);
      // console.error(JSON.stringify(err));

      alertAccountExistsWithDifferentCredential(err);
    }
  }, [navigate]);

  const twitter = useCallback(async () => {
    const searchParams = new URLSearchParams();
    searchParams.append("client_id", process.env.REACT_APP_MRLOGIN_CLIENT_ID);
    searchParams.append(
      "redirect_uri",
      `${document.location.origin}${ROUTES.CallbacksMrlogin}`
    );
    try {
      window.open(
        `https://mrlogin.io/login?${searchParams.toString()}`,
        "click-mrlogin",
        "width=500, height=600"
      );
    } catch (err) {
      console.error(JSON.stringify(err));
    }
  }, []);

  return (
    <>
      <Stack direction="row" spacing={2}>
        <Button
          fullWidth
          size="large"
          color="inherit"
          variant="outlined"
          onClick={google}
        >
          <Icon icon={googleFill} color="#DF3E30" height={24} />
        </Button>

        <Button
          fullWidth
          size="large"
          color="inherit"
          variant="outlined"
          onClick={facebook}
        >
          <Icon icon={facebookFill} color="#1877F2" height={24} />
        </Button>

        <Button
          fullWidth
          size="large"
          color="inherit"
          variant="outlined"
          onClick={twitter}
        >
          <Icon icon={twitterFill} color="#1C9CEA" height={24} />
        </Button>
      </Stack>

      <Divider sx={{ my: 3 }}>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          OR
        </Typography>
      </Divider>
    </>
  );
}
